import { ClickButtonInstruction } from '../ClickButtonInstruction'

export class ClickNextInstruction extends ClickButtonInstruction {
  constructor ({ waitForNoLoaders, isVisible }) {
    super({
      name: 'Next',
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      className: 'action continue primary',
      click: true,
      isVisible: isVisible === undefined ? true : isVisible

    })
  }
}
